export const mauIn = {
  titles: {
    list: '打印模板',
    edit: '编辑打印模板',
    hoaDon: '发票打印模板',
  },
  subtitle: '每个页面有独立的打印模板和字段',
  screens: {
    title: '页面',
    groups: {
      giaoDich: '交易',
      soQuy: '资金',
      kho: '库存',
      giaoHang: '配送',
    },
    items: {
      'hoa-don': '发票',
      'hoa-don-ycsc': '维修发票',
      'tra-hang': '退货',
      'dat-hang': '订单',
      'yeu-cau-sua-chua': '维修',
      'phieu-thu': '收款单',
      'phieu-chi': '付款单',
      'phieu-nhap-kho': '入库',
      'phieu-xuat-kho': '出库',
      'chuyen-hang': '调拨',
      'phieu-nhan-hang': '收货单',
      'kiem-ke': '盘点',
      'tem-hang-hoa': '标签',
      'nhan-giao-hang': '运单',
    },
  },
  tabs: {
    pdf: 'PDF',
    excel: 'Excel',
  },
  sections: {
    header: '页眉信息',
    body: '发票信息',
    table: '商品表格',
    totals: '金额合计',
    signature: '签名',
    footer: '页脚备注',
    preview: '预览',
  },
  fields: {
    paperSize: '纸张大小',
    logoUrl: 'Logo 地址',
    tenCongTy: '公司名称',
    dongDiaChi1: '地址行 1',
    dongDiaChi2: '地址行 2',
    hotline: '热线',
    website: '网站',
    tieuDeHoaDon: '模板标题',
    thongTinTrai: '左侧信息栏',
    thongTinPhai: '右侧信息栏',
    cot: '表格列',
    cotTieuDe: '列标题',
    cotHienThi: '显示',
    tongTienHangHienThi: '显示小计',
    chietKhauHienThi: '显示折扣',
    tongThanhToanHienThi: '显示应付总额',
    hienThiTongBangChu: '显示大写金额',
    chuKy: '签名框',
    chuKyTieuDe: '签名框标题',
    chuKyGhiChu: '签名框备注',
    ngayThangNamLine: '日期行',
    ghiChuFooter: '页脚备注',
    saveMauInName: '模板名称',
    saveMauInNamePlaceholderPdf: '例如：标准 A4 发票',
    saveMauInNamePlaceholderExcel: '例如：财务 Excel 发票',
    saveMauInPrivate: '仅自己',
    saveMauInPublic: '共享',
  },
  studio: {
    paper: '纸张',
    orientation: '纸张方向',
    portrait: '纵向',
    landscape: '横向',
    marginTop: '上边距 (mm)',
    marginRight: '右边距 (mm)',
    marginBottom: '下边距 (mm)',
    marginLeft: '左边距 (mm)',
    appearance: '表格样式',
    fontFamily: '字体',
    tableHeaderBg: '表头背景色',
    tableBorder: '表格边框',
    zebra: '隔行底色',
    textStyle: '文字样式',
    textColor: '文字颜色',
    textSection: {
      title: '标题',
      header: '页眉',
      tableHeader: '表头',
      tableBody: '表体',
      signatures: '签名',
      totals: '合计',
    },
    totalsRows: '显示的行',
    totalsLook: '合计样式',
    totalsLayout: '边框',
    totalsLayoutGrid: '网格',
    totalsLayoutLines: '横线',
    totalsLayoutPlain: '无',
    totalsWidth: '宽度',
    totalsWidthFull: '整页',
    totalsWidthRight: '右侧 {pct}%',
    totalsHighlightLast: '突出最后一行（应付总额）',
    selectedColumns: '已选列',
    addColumn: '添加列',
    sampleData: '示例数据',
    viewSheet: '查看单据',
    editSheet: '编辑模板',
    previewSummary: '{rows} 行 · {cols} 列',
    blocks: '单据结构',
    addBlock: '添加区块',
    addGroupBasic: '基础区块',
    addGroupTable: '表格与合计',
    addGroupPreset: '快捷版式',
    preset: {
      company: '公司信息',
      signatures: '签名',
      qrCode: '单据编号二维码',
      trackingBarcode: '运单号条码',
    },
    sheetTemplates: {
      open: '现成模板',
      openHint: '为整张单据选择现成版式——保留公司信息、列和签名。Ctrl+Z 撤销。',
      title: '现成打印模板',
      subtitle: '点击模板即可应用到整张单据。公司信息、表格列和签名保持不变。',
      applyHover: '使用此模板',
      applied: '已应用「{name}」。按 Ctrl+Z 可撤销。',
      defaultBadge: '默认',
      khoBadge: '仓库标准',
      items: {
        'kho-pgh-v1': {
          name: '送货单 V1',
          desc: '仓库作业单据：标志 + 地址、运单号、图片 · 库位 · 规格、件数汇总，仓管 / 运输 / 收货人签名。',
        },
        'kho-pgh-v1-plain': {
          name: '送货单 V1 · 无标志',
          desc: '不含分店标志和地址的送货单 V1。',
        },
        'kho-hd-v1': {
          name: '销售发票 V1',
          desc: '仓库作业单据，含售价、金额、应付合计及大写金额，带标志 + 地址。',
        },
        'kho-hd-v1-plain': {
          name: '销售发票 V1 · 无标志',
          desc: '不含分店标志和地址的销售发票 V1。',
        },
        'kho-pgh-v2': {
          name: '送货单 V2',
          desc: '同 V1，增加包裹尺寸（cm）和包裹重量（kg）列。',
        },
        'kho-pgh-v2-plain': {
          name: '送货单 V2 · 无标志',
          desc: '不含分店标志和地址的送货单 V2。',
        },
        'kho-hd-v2': {
          name: '销售发票 V2',
          desc: '销售发票 V1 增加包裹尺寸和包裹重量列。',
        },
        'kho-hd-v2-plain': {
          name: '销售发票 V2 · 无标志',
          desc: '不含分店标志和地址的销售发票 V2。',
        },
        'kho-logo': {
          name: '仓库标准 · 带标志',
          desc: '与旧仓库单据一致：标志 + 地址、条形码、信息框 + 二维码、灰色表格、三方签名。',
        },
        'kho-plain': {
          name: '仓库标准 · 无标志',
          desc: '不含标志和地址的仓库单据——适用于预印抬头纸。',
        },
        'kho-a5': {
          name: '紧凑仓库 · A5',
          desc: 'A5 紧凑仓库单据：字体较小、单据条形码、去掉二维码以适合半张 A4。',
        },
        modern: {
          name: '现代',
          desc: '深蓝强调色、大标题、表头底色和斑马纹。',
        },
        classic: {
          name: '经典',
          desc: 'Times 字体、居中页眉双线、合计横线——会计凭证风格。',
        },
      },
    },
    library: {
      open: '预设区块',
      openHint: '选择预先设计好的区块组（页眉、页脚、签名…），稍作修改即可',
      title: '预设区块库',
      subtitle: '点击模板即可添加到单据。添加后仍可像普通区块一样修改文字、Logo、对齐方式。',
      more: '查看全部预设区块…',
      insert: '添加',
      insertHover: '添加到单据',
      emptyTitle: '单据为空',
      emptyHint: '使用预设区块快速开始：选择页眉、信息区、签名和页脚。',
      filterLabel: '筛选：',
      noMatch: '没有符合此筛选条件的区块。',
      filter: {
        all: '全部',
        logo: '带 Logo',
        noLogo: '无 Logo',
        qr: '带二维码',
        tracking: '运单号',
      },
      tag: {
        logo: 'Logo',
        qr: '二维码',
        barcode: '条码',
        tracking: '运单',
      },
      placement: {
        top: '添加到顶部',
        bottom: '添加到底部',
        selected: '添加到所选区块之后',
        selectedInside: '添加到所选分组内',
      },
      category: {
        all: '全部',
        header: '页眉',
        title: '标题',
        info: '信息',
        shipping: '物流',
        signature: '签名',
        footer: '页脚',
      },
      items: {
        'header-logo-left': { name: 'Logo 居左 + 信息', desc: '左侧 Logo，右侧公司名称、地址、热线。' },
        'header-big-logo': { name: '大 Logo + 地址', desc: '左侧大 Logo，公司名称大字号——类似仓库送货单。' },
        'header-centered': { name: '居中带 Logo', desc: 'Logo、公司名称和地址居中，下方带分隔线。' },
        'header-company-qr': { name: 'Logo + 信息 + 二维码', desc: 'Logo、公司信息，右侧为单据二维码。' },
        'header-title-meta': { name: 'Logo + 标题 + 单号', desc: 'Logo、居中标题，右侧为单号和打印日期。' },
        'header-text-only': { name: '纯文字（无 Logo）', desc: '左侧公司名称、地址；右侧单号、日期；粗分隔线。' },
        'header-minimal': { name: '极简单行', desc: '公司名称和热线在同一行，下方细线。' },
        'header-text-qr': { name: '文字 + 二维码（无 Logo）', desc: '左侧公司信息，右侧单据二维码。' },
        'title-center': { name: '居中标题', desc: '大标题、单号和日期行居中显示。' },
        'title-meta-row': { name: '标题 + 单号行', desc: '大标题，下方左侧单号、右侧时间。' },
        'title-tracking-meta': { name: '标题 + 运单号', desc: '标题下方显示 单号 · 运单号 · 时间——仓库单据样式。' },
        'title-tracking-barcode': { name: '运单条码 + 标题', desc: '上方运单条码，下方标题和 单号 · 运单号 · 时间。' },
        'title-barcode': { name: '标题 + 单号条码', desc: '左侧标题和日期，右侧单号条码。' },
        'title-qr-right': { name: '标题 + 二维码', desc: '左侧标题、单号、日期；右侧单据二维码。' },
        'info-two-cols': { name: '两列信息（紧随）', desc: '两列排列，值紧跟在「标签:」后面。' },
        'info-aligned-one-col': { name: '对齐信息', desc: '标签一列、值一列对齐——每个字段一行。' },
        'info-aligned-two-cols': { name: '两列对齐信息', desc: '两列，每列的标签和值各自对齐。' },
        'info-aligned-qr': { name: '对齐信息 + 二维码', desc: '左侧标签 / 值对齐，右侧单据二维码。' },
        'info-aligned-recipient': { name: '客户 | 单据', desc: '两个带标题的区块：客户信息和单据信息，标签对齐。' },
        'info-one-col': { name: '单列信息（紧随）', desc: '每个字段一行，值紧跟标签——适合 A5。' },
        'info-boxed': { name: '信息框', desc: '全部信息放在一个边框内，标签加粗。' },
        'info-boxed-two-cols': { name: '两列信息框', desc: '两个边框并排，字段平分。' },
        'info-boxed-qr': { name: '信息框 + 二维码', desc: '左侧信息框，右侧大二维码——仓库单据样式。' },
        'info-recipient-tracking': { name: '收件人 + 运单号', desc: '收件人框（姓名、电话、地址），右侧运单条码。' },
        'ship-tracking-barcode': { name: '大号运单条码', desc: '居中大号运单条码，下方显示号码。' },
        'ship-tracking-qr': { name: '运单条码 + 二维码', desc: '左侧运单号和条码，右侧单据二维码。' },
        'ship-label': { name: '发货标签', desc: '寄件人 / 收件人框并排，下方运单条码。' },
        'ship-carrier-box': { name: '物流框 + 运单二维码', desc: '运单号、单号、发货日期、配送备注；运单号二维码。' },
        'signature-screen': { name: '按界面签名', desc: '此界面的默认签名栏，横向排列。' },
        'signature-received': { name: '日期 + 已收齐 + 签名', desc: '日期、「已收齐」行和签名栏——仓库单据样式。' },
        'signature-two': { name: '双方签名', desc: '制单人和客户，带签名提示。' },
        'signature-date-right': { name: '日期 + 右侧签名', desc: '右侧显示日期行和制单人签名。' },
        'signature-confirm': { name: '确认 + 收件人签名', desc: '左侧验货确认语，右侧收件人签名。' },
        'footer-thanks': { name: '感谢语', desc: '虚线和居中的感谢语。' },
        'footer-notes': { name: '收货注意事项', desc: '收货 / 订单投诉注意事项及祝福语——仓库单据样式。' },
        'footer-contact': { name: '热线 + 网站', desc: '分隔线，左侧热线，右侧网站。' },
        'footer-qr-note': { name: '二维码 + 备注', desc: '查询二维码和结尾备注。' },
        'footer-tracking-lookup': { name: '运单查询 + 二维码', desc: '查询提示、运单号、热线和运单号二维码。' },
        'footer-policy': { name: '退换货政策', desc: '退换货政策框和打印时间。' },
      },
    },
    selectBlockHint: '选择一个区块以移动、复制、隐藏或删除',
    treeHideBlock: '隐藏区块（不打印）',
    treeShowBlock: '显示区块',
    treeCollapseAll: '折叠',
    treeExpandAll: '全部展开',
    treeCollapseGroup: '折叠分组',
    treeExpandGroup: '展开分组',
    templates: '打印模板',
    templatesCount: '{count} 个模板',
    clickToEdit: '点击纸张选择区块 · 再次点击编辑内容 · 按 Delete 删除',
    showStructure: '显示区块结构',
    hideStructure: '隐藏区块结构',
    structureHint: '虚线框和名称标签显示每个区块。关闭后可查看接近打印效果的纸张。',
    blockChip: {
      page: '纸张',
    },
    undo: '撤销',
    redo: '重做',
    clearAllBlocks: '清空全部',
    sheet: '工作表',
    sheetEmptyHint: '单击选择单元格，拖动选择区域，或 Shift+单击 / Shift+方向键扩展。合并与取消合并在预览栏。在右侧输入内容或插入变量。',
    sheetSelectionOne: '已选择 {cell}',
    sheetSelectionRange: '已选择 {from}:{to}',
    mergeCells: '合并',
    mergeCellsHint: '拖动或 Shift+单击选择区域，再合并为一个单元格',
    unmergeCells: '取消合并',
    unmergeCellsHint: '选中已合并的单元格后拆回独立单元格',
    zoomIn: '放大',
    zoomOut: '缩小',
    zoomReset: '恢复 100%',
    fitWidth: '适应宽度（纸张更大，纵向滚动）',
    colResizeHint: '拖动调整列宽 · 双击恢复默认',
    fitPage: '显示整页',
    undoShortcut: '撤销 (Ctrl+Z)',
    redoShortcut: '重做 (Ctrl+Y)',
    saveShortcut: '保存 (Ctrl+S)',
    unsaved: '未保存',
    resetStyle: '重置此区块样式',
    selectAll: '全选',
    selectNone: '全不选',
    showBlock: '显示此区块',
    blockName: '区块名称',
    infoBlankHint: '空白模板：勾选下方字段，或添加文本行 / 字段行来填写内容。',
    addInfoText: '添加文本行',
    addInfoFieldRow: '添加字段行',
    addInfoField: '添加已有字段',
    addChildBlock: '添加子块',
    treeMoveIn: '移入内层',
    treeMoveOut: '移出外层',
    treeCopyBlock: '复制区块',
    treeCopySuffix: ' (副本)',
    treeMoveUp: '上移',
    treeMoveDown: '下移',
    treeDeleteBlock: '删除区块',
    blockKind: '区块类型',
    childrenLayout: '排列方向',
    childrenLayoutVertical: '纵向',
    childrenLayoutHorizontal: '横向',
    childrenLayoutHint: '子区块默认纵向排列。选择横向则并排显示。',
    childrenWidth: '子区块宽度 (mm)',
    childrenWidthHint: '填写 mm 可固定列宽。留空则占用剩余空间。Logo 使用固定宽×高。',
    childrenWidthExcel: '子区块宽度（Excel 列）',
    childrenWidthHintExcel: '填写占用的 Excel 列数（A、B、C…）。留空则占用该行剩余列。',
    blockWidthMm: '区块宽度 (mm)',
    blockWidthCols: '区块宽度（列）',
    excelLayout: 'Excel 单元格布局',
    excelLayoutHint: '填写起始列（1 = A）和列数。例如：起始 1、列数 4 = A→D。',
    excelColStart: '起始列',
    excelColCount: '列数',
    excelColEnd: '结束列',
    excelColEndAuto: '到行末（自动）',
    excelRowHeightPt: '行高',
    excelRowHeightHint: '与 Excel（设置行高）相同单位。留空则按内容自适应。Excel 默认约 15。',
    infoNestHint: '选中此区块后点「添加子块」，可在内部嵌套文本/字段行等（同 YTL），支持多级。',
    align: '对齐',
    alignLeft: '左',
    alignCenter: '中',
    alignRight: '右',
    bold: '加粗',
    italic: '斜体',
    underline: '下划线',
    fontSize: '字号 (pt)',
    textContent: '内容',
    textVarsHint: '输入固定文字，点「插入变量」添加单据数据。',
    insertVar: '插入变量',
    varTextPlaceholder: '输入文字…',
    varGroupCommon: '通用',
    varGroupInfo: '单据信息',
    varGroupColumns: '表格列',
    varGroupExtra: '其他',
    varDay: '日',
    varMonth: '月',
    varYear: '年',
    varAmountInWords: '金额大写',
    textCase: '大小写',
    textCaseNone: '保持原样',
    textCaseUpper: '全部大写',
    textCaseLower: '全部小写',
    textCaseSentence: '句首大写',
    marginTopMm: '上间距 (mm)',
    marginBottomMm: '下间距 (mm)',
    logoWidth: 'Logo 宽 (mm)',
    logoWidthCols: 'Logo 宽（列）',
    logoHeight: 'Logo 高 (mm)',
    logoImage: 'Logo 图片',
    logoChoose: '选择图片',
    logoPaste: '粘贴图片',
    logoDragDrop: '拖放图片到此处',
    logoPasteHint: '或粘贴图片 / http(s) 链接',
    logoFit: 'Logo 适配',
    logoFitContain: 'Contain',
    logoFitCover: 'Cover',
    logoFitFill: 'Fill',
    barcodeField: '编码内容',
    barcodeCode: '单据编号',
    qrSizeMm: '二维码尺寸 (mm)',
    barcodeHeightMm: '条码高度 (mm)',
    codeShowText: '在编码下方打印文字',
    qrHint: '用手机或扫码枪可扫出准确内容。单据无数据时自动隐藏。',
    barcodeHint: 'Code 128 条码——仅支持无重音字母和数字。发票尚无运单号时自动隐藏。',
    todayVar: '今天',
    fieldKey: '数据字段',
    fieldLabel: '行标签',
    labelWidthPct: '标签宽度 (%)',
    valueWidthPct: '值宽度 (%)',
    labelWidthMm: '标签宽度 (mm)',
    labelWidthAuto: '自动',
    labelWidthApply: '应用到整组',
    labelWidthApplyHint: '为本组内所有带标签的行设置相同标签宽度，使值对齐成一列。留空 = 值紧跟标签。',
    colorNone: '无颜色',
    colorCustom: '选择其他颜色',
    sectionFrame: '边框和底色',
    frameNone: '无',
    frameSolid: '实线',
    frameDashed: '虚线',
    frameDotted: '点线',
    frameColor: '边框颜色',
    fillColor: '底色',
    paddingMm: '内边距 (mm)',
    childGapMm: '子区块间距 (mm)',
    childGapDefault: '默认',
    childAlign: '垂直对齐',
    childAlignTop: '顶部对齐',
    childAlignCenter: '居中对齐',
    childAlignBottom: '底部对齐',
    tableHeaderBgShort: '表头底色',
    tableBorderShort: '表格边框',
    tableZebraBgShort: '隔行底色',
    pageMargins: '页边距 (mm)',
    marginsLink: '四边相同',
    marginsUnlink: '分别设置各边',
    marginTopShort2: '上',
    marginRightShort: '右',
    marginBottomShort2: '下',
    marginLeftShort: '左',
    labelWidthCols: '标签列数',
    labelWidthColsHint: '块内剩余列用于值。',
    dividerStyle: '样式',
    dividerSolid: '实线',
    dividerDashed: '虚线',
    dividerDotted: '点线',
    dividerSpace: '仅空白',
    sectionContent: '内容',
    sectionArrange: '子区块布局',
    sectionFormat: '文字格式',
    sectionSize: '尺寸',
    sectionLayout: '位置与间距',
    fontSizeShort: '字号',
    textCaseShort: '大小写',
    colorShort: '颜色',
    dividerWidthShort: '粗细 (pt)',
    widthMmShort: '宽 (mm)',
    heightMmShort: '高 (mm)',
    widthColsShort: '宽 (列)',
    marginTopShort: '上间距 (mm)',
    marginBottomShort: '下间距 (mm)',
    autoWidth: '自动',
    textLabel: '标签（可选）',
    textBody: '文字与数据变量',
    stylePart_value: '变量值样式',
    stylePartReset: '重置样式',
    textLabelPlaceholder: '例：客户 → 打印「客户: …」',
    dividerWidth: '分隔线粗细 (pt)',
    dividerColor: '分隔线颜色',
    spacerHeight: '空白高度 (mm)',
    noteBorder: '加边框',
    blockGap: '区块间距 (mm)',
    lineHeight: '行高',
    accentColor: '强调色',
    tableZebraBg: '隔行底色',
    tableCellPadding: '单元格内边距 (pt)',
    formulas: '公式列',
    addFormula: '添加公式列',
    formulaLabel: '列名',
    addTerm: '添加项',
    termOp: '运算符',
    termKind: '来源',
    termField: '列',
    termNumber: '常数',
    termKindField: '数据列',
    termKindNumber: '常数',
    formulaPreview: '公式',
    kind: {
      group: '区块组',
      table: '数据表',
      totals: '合计',
      text: '文本',
      variable: '数据变量',
      fieldRow: '字段行',
      divider: '分隔线',
      spacer: '空白',
      note: '框式备注',
      logo: 'Logo',
      barcode: '条码',
      qrcode: '二维码',
      clone: '副本',
    },
    family: {
      text: '文本 / 数据',
      group: '区块组',
      logo: 'Logo / 图片',
      code: '二维码 / 条码',
      line: '分隔线 / 空白',
      table: '数据表',
      totals: '合计',
    },
    familyHint: {
      text: '固定文字、插入变量，可加标签或边框',
      group: '包含子区块，纵向或横向排列',
      logo: '分店 Logo 或上传图片',
      code: '按单据号、运单号生成二维码 / Code 128',
      line: '横线或空白间距',
      table: '商品明细，可拖动调整列宽',
      totals: '合计、折扣、大写金额',
    },
    block: {
      page: '纸张 / 边距',
      title: '标题',
      header: '页眉',
      info: '单据信息',
      table: '数据表',
      totals: '合计',
      date: '日期',
      signatures: '签名',
      footer: '页脚',
    },
  },
  excel: {
    infoRows: '信息行',
    showCustomer: '客户',
    showInvoiceNo: '发票号',
    showPhone: '电话',
    showBranch: '分店',
    showAddress: '地址',
    showSeller: '销售员',
    showNote: '备注',
    showTotals: '合计',
    showAmountInWords: '大写金额',
    columnOrder: '列顺序 / 标题',
    tableHeaderBg: '表头背景色',
    columnDetail: '列详情',
    columnWidth: '列宽',
    columnHint: '列宽按 Excel 字符计。可在预览区拖动 A、B、C 列边调整。',
    resizeHint: '拖动列边缘调整宽度',
    emptyPreview: '尚无区块 — 请在结构栏添加区块后预览。',
    fmt: {
      bold: '加粗 (Ctrl+B)',
      italic: '斜体 (Ctrl+I)',
      underline: '下划线 (Ctrl+U)',
      alignLeft: '左对齐',
      alignCenter: '居中',
      alignRight: '右对齐',
      fontSize: '字号',
      textColor: '文字颜色',
      fillColor: '填充颜色',
      noTarget: '请选择有内容的单元格或表格列进行格式设置',
      columnOnly: '表格列仅支持加粗和对齐',
    },
    formulaBar: {
      readOnly: '此单元格自动填充 — 请在左侧属性面板修改',
      placeholder: '输入单元格内容… 用 {字段} 插入数据',
      empty: '选择单元格以查看 / 编辑内容',
    },
    sheet: {
      open: '工作表设置',
      title: 'Excel 文件设置',
      sheetName: '工作表名称',
      sheetNamePlaceholder: '默认：{name}',
      fileName: '文件名',
      fileNameHint: '{code} = 单据编号，{ngay} = 导出日期',
      page: '页面设置',
      paper: '纸张',
      portrait: '纵向',
      landscape: '横向',
      fitWidth: '所有列缩放到一页宽',
      repeatHeader: '每页重复表头',
      view: '视图',
      freezeHeader: '冻结至表头行',
      gridLines: '显示 Excel 网格线',
      autoFilter: '表头启用筛选',
      zebra: '表格隔行着色',
      borders: '边框',
      bordersTable: '表格和边框',
      bordersAll: '所有单元格',
      bordersNone: '无',
      numberFormat: '数字列',
      numberInt: '1,234',
      numberDec2: '1,234.00',
      numberText: '保留文本',
      numberHint: '数字格式可在 Excel 中直接求和 / 筛选。',
    },
  },
  copy: {
    title: '复制打印模板',
    suffix: '副本',
    name: '副本名称',
    targetScreen: '目标页面',
    sameKindPdf: '只能复制为其他页面的 PDF 模板。',
    sameKindExcel: '只能复制为其他页面的 Excel 模板。',
    targetProjects: '目标项目',
    selectAll: '全选（{n} 个项目）',
    current: '当前',
    onlyCurrentProject: '副本将创建在当前项目中。',
    keepPublic: '源模板为共享 → 副本也为共享（目标项目所有人可用）。',
    keepPrivate: '源模板为私有 → 副本为您的私有模板。',
    submit: '创建 {n} 个副本',
    success: '已创建 {n} 个模板副本。',
    skipped: '已跳过 {n} 个无权限的项目。',
    needName: '请输入副本名称。',
    needProject: '请至少选择 1 个目标项目。',
    loadProjectsError: '无法加载项目列表。',
    saveError: '无法复制模板，请重试。',
  },
  actions: {
    save: '保存模板',
    resetDefault: '恢复默认',
    printTest: '测试打印',
    exportExcelTest: '测试导出 Excel',
    insertPlaceholder: '插入变量',
    addLine: '添加行',
    removeLine: '删除行',
    addChuKy: '添加签名框',
    removeChuKy: '删除签名框',
    mauInCreateNew: '新建模板',
    deleteMauIn: '删除模板',
    copyMauIn: '复制模板',
    saveMauIn: '保存模板',
    updateMauIn: '更新模板',
    saveAs: '另存为新模板',
    saveAsHint: '保留当前模板，将这些修改另存为新模板',
    discardChanges: '放弃修改',
    discardChangesHint: '恢复到上次保存的版本。可用撤销 (Ctrl+Z) 找回。',
    rebuildDefaultLayout: '重建默认版式',
    rebuildDefaultLayoutHint: '用此界面的标准模板替换整个版式。点击保存前不会保存；可撤销 (Ctrl+Z)。',
    discardAndContinue: '放弃并继续',
  },
  messages: {
    loadError: '加载打印模板失败。',
    saveSuccess: '打印模板已保存。',
    saveError: '保存打印模板失败。',
    resetSuccess: '已恢复默认。',
    resetConfirm: '恢复为默认模板？所有更改将丢失。',
    isDefault: '使用默认模板',
    isCustom: '已自定义',
    noMauInPdf: '暂无 PDF 模板',
    noMauInExcel: '暂无 Excel 模板',
    mauInInvalid: '模板无效或缺少配置',
    mauInPublicBadge: '共享',
    mauInReorderHint: '拖放以排序 — 打印时的模板列表按此顺序显示。',
    mauInReorderFailed: '无法保存模板顺序，请重试。',
    mauInDeleteTitle: '删除打印模板',
    mauInDeleteConfirm: '删除“{name}”？打印时的模板列表中将不再显示。',
    mauInDeleted: '已删除“{name}”。',
    mauInDeleteFailed: '无法删除模板，请重试。',
    noEditPermission: '账号未获授予“编辑打印模板”权限，仅可查看和测试打印。',
    mauInKindTitle: '模板类型',
    mauInListTitle: '已有模板（{count}）',
    mauInDraftNew: '新模板（未保存）',
    saveMauInNameRequired: '请输入模板名称',
    saveMauInSuccess: '模板已保存到服务器',
    updateMauInSuccess: '模板已更新',
    selectMauInRequired: '导出前请先选择模板',
    unsavedTitle: '模板尚未保存',
    unsavedConfirm: '您有未保存的修改，继续操作将丢失这些修改。',
  },
  placeholders: {
    help: '使用 {变量名} 插入动态数据。例如：{Ma_Don_Hang}、{Khach_Hang}、{Tong_Cong}。',
  },
  v2: {
    pageBreak: '分页符',
    hints: {
      lineVarOutsideRepeat: '无法插入：商品行字段只能放在标记为“按商品重复”的表格行中。请将光标放到该行后再插入。',
      totalVarOutsideRepeat: '无法插入：合计字段只能放在标记为“按合计行重复”的表格行中。请将光标放到该行后再插入。',
      groupVarOutsideRepeat: '无法插入：维修商品字段只能放在“按维修商品重复”的块中。请将光标放到该块后再插入。',
    },
    messages: {
      uploadError: '图片上传失败',
    },
    canvas: {
      showSample: '显示示例数据',
    },
    toolbar: {
      undo: '撤销 (Ctrl+Z)',
      redo: '重做 (Ctrl+Y)',
      block: '段落样式',
      blockNormal: '正文',
      blockH1: '标题 1',
      blockH2: '标题 2',
      blockH3: '标题 3',
      font: '字体',
      fontDefault: '默认',
      fontSize: '字号 (pt)',
      bold: '加粗 (Ctrl+B)',
      italic: '斜体 (Ctrl+I)',
      underline: '下划线 (Ctrl+U)',
      strike: '删除线',
      color: '文字颜色',
      highlight: '文字底色',
      clearColor: '无颜色',
      clearFormat: '清除格式',
      align: {
        left: '左对齐',
        center: '居中',
        right: '右对齐',
        justify: '两端对齐',
      },
      bulletList: '项目符号列表',
      orderedList: '编号列表',
      insert: '插入',
      table: '表格',
      linesTable: '商品表',
      linesTableHint: '插入商品表：表头行 + 按商品重复的行',
      repairGroups: '维修商品块',
      repairGroupsHint: '插入按维修商品重复的块（1张单据→多个商品），每块含替换件/服务表',
      totalsTable: '合计表',
      totalsTableHint: '插入合计表（按合计行重复）',
      signatures: '签名',
      logo: 'Logo',
      logoHint: '插入分店 Logo — 打印时自动使用分店 Logo',
      image: '图片',
      uploading: '上传中…',
      qr: '二维码',
      barcode: '条形码',
      hr: '水平线',
      pageBreak: '分页符',
    },
    table: {
      title: '表格',
      rowAbove: '在上方插入行',
      rowBelow: '在下方插入行',
      colLeft: '在左侧插入列',
      colRight: '在右侧插入列',
      addRow: '行',
      addCol: '列',
      above: '上',
      below: '下',
      left: '左',
      right: '右',
      headerRow: '标题行',
      delete: '删除',
      merge: '合并单元格',
      split: '拆分单元格',
      deleteRow: '删除行',
      deleteCol: '删除列',
      deleteTable: '删除表格',
      borders: '边框',
      bordersAll: '实线',
      bordersDashed: '虚线',
      bordersNone: '无边框',
      repeat: '本行',
      repeatNone: '普通行',
      repeatLines: '按商品重复',
      repeatTotals: '按合计行重复',
      repeatHint: '重复行在打印时会被复制 — 每个商品（或每个合计行）一行。请将“商品行”字段放在此行。',
      vAlign: '垂直对齐',
      vTop: '顶部',
      vMiddle: '居中',
      vBottom: '底部',
      cellBg: '单元格底色',
      toggleHeaderRow: '切换表头行',
      resizeHint: '拖动竖线调整列宽（表格总宽不变），双击可平分两列。选中多个单元格可合并。',
    },
    vars: {
      title: '数据字段',
      hint: '点击在光标处插入，或拖放到页面上。',
      search: '搜索字段…',
      groups: {
        info: '单据信息',
        general: '通用',
        line: '商品行',
        total: '合计行',
      },
      sections: {
        group: '维修商品（分组）',
        line: '替换件/服务（逐行）',
        voucher: '单据信息',
        customer: '客户',
        staff: '门店与员工',
        money: '金额与付款',
        delivery: '配送与包装',
        repair: '维修申请',
        code: '运单号 / 二维码',
        general: '日期与通用',
        total: '合计行',
      },
      groupHints: {
        group: '放在“按维修商品重复”的块中（1张单据→多个维修商品）。',
        line: '放在“按商品重复”的表格行中（每个维修商品下可有多个替换件）。',
        total: '放在“按合计行重复”的表格行中。',
      },
    },
    props: {
      qrTitle: '二维码',
      barcodeTitle: '条形码',
      codeType: '类型',
      codeSource: '数据',
      codeCustom: '自定义…',
      codeCustomPlaceholder: '例如：{code} 或 https://…',
      codeCustomHelp: '可组合文字和字段，例如 https://shop.com/order/{code}',
      qrSize: '尺寸',
      barcodeHeight: '高度',
      barcodeWidth: '宽度',
      auto: '自动',
      codeShowText: '在码下方显示文字',
      resizeHint: '拖动角或边上的控制点可调整大小。',
      logoTitle: '分店 Logo',
      imageTitle: '图片',
      imageWidth: '宽度',
      logoHint: '打印时自动使用分店 Logo（设置 → 打印 Logo）。',
    },
    page: {
      title: '页面',
      paper: '纸张',
      orientation: '方向',
      portrait: '纵向',
      landscape: '横向',
      margins: '页边距',
      top: '上',
      bottom: '下',
      left: '左',
      right: '右',
      font: '默认字体',
      fontSize: '字号',
      lineHeight: '行距',
      soBan: '打印份数',
      soBanUnit: '份',
      soBanHint: '每次打印自动输出全部份数，每份从新页开始。',
      soTrang: '页码',
      soTrangNone: '不显示',
      soTrangLeft: '页脚 · 左',
      soTrangCenter: '页脚 · 中',
      soTrangRight: '页脚 · 右',
      soTrangHint: '“页 x/y”位于下边距内，建议下边距不小于 10 mm。',
    },
  },
  xv2: {
    exporting: '正在导出…',
    formula: {
      placeholder: '单元格内容 — 输入文字，插入变量如 {code}，以 = 开头可计算（如 ={tongCong}+{thuKhac}）',
      help:
        '公式：单元格以 = 开头（如 =4+5+6 → 15，={tongCong}-{giamGia}），或在文字中插入 {= ... }。\n' +
        '运算：+ - * / ^ %，用 & 连接文字（如 ={customer} & " - " & {phone}），比较 = <> < > <= >=。\n' +
        '函数：SUM, ROUND, ROUNDUP, ROUNDDOWN, MIN, MAX, ABS, AVERAGE, IF, AND, OR, NOT, CONCAT, UPPER, LOWER, TRIM, LEN, LEFT, RIGHT, TEXT(x; 小数位), BANGCHU(x)。\n' +
        '变量无需放在任何单元格中。勾选“显示示例数据”查看结果；公式错误显示 #LỖI。',
    },
    hints: {
      lineVarOutsideRepeat: '无法插入：商品行变量只能放在设为“按商品重复”的行中（右键 → 重复行）。',
      totalVarOutsideRepeat: '无法插入：合计变量只能放在设为“按合计行重复”的行中（右键 → 重复行）。',
    },
    messages: {
      exportError: '导出 Excel 文件失败',
      imagesMissing: '无法加载 {n} 个 Logo/图片（服务器图片代理无响应）— Excel 文件已导出但缺少图片。',
    },
    toolbar: {
      fill: '填充颜色',
      v: {
        top: '顶端对齐',
        middle: '垂直居中',
        bottom: '底端对齐',
      },
      wrap: '自动换行',
      borderOn: '添加边框',
      borderOff: '去除边框',
      merge: '合并',
      mergeHint: '将选中的单元格合并为一个',
      unmerge: '取消合并',
      linesTableHint: '在选中单元格插入商品表：标题行 + 按商品重复的行',
      totalsRow: '合计行',
      totalsRowHint: '插入合计行（按单据的合计行重复）',
      rowRepeat: '行',
      rowRepeatHint: '重复行在导出时会被复制 — 每个商品 / 每个合计行一行',
    },
    vars: {
      colField: '字段',
      colSample: '示例数据',
      empty: '没有匹配的字段',
      groupHints: {
        line: '放在“按商品重复”的行中。',
        total: '放在“按合计行重复”的行中。',
      },
    },
    grid: {
      insertRowAbove: '在上方插入 {n} 行',
      insertRowBelow: '在下方插入 {n} 行',
      insertColLeft: '在左侧插入 {n} 列',
      insertColRight: '在右侧插入 {n} 列',
      deleteRows: '删除 {n} 行',
      deleteCols: '删除 {n} 列',
      merge: '合并单元格',
      unmerge: '取消合并',
      clear: '清除内容',
      repeatLines: '按商品重复此行',
      repeatTotals: '按合计行重复此行',
      repeatNone: '取消重复',
      repeatLinesHint: '按商品重复 — 导出时每个商品一行',
      repeatTotalsHint: '按合计行重复 — 导出时每个合计行一行',
      logoPlaceholder: 'LOGO',
      widthBadge: '宽度：{w}（{px} px）',
      heightBadge: '高度：{h} pt（{px} px）',
      colGripHint: '拖动调整列宽 · 双击自动适应内容',
      rowGripHint: '拖动调整行高 · 双击恢复默认',
    },
    props: {
      width: '宽',
      height: '高',
      objectHint: '锚定在单元格 {cell}。拖动可移动，拖动角 / 边的控制点可调整大小，方向键微调。',
      replaceImage: '更换图片',
      deleteObject: '删除',
    },
    cell: {
      title: '单元格 {range}',
      repeatHint: '重复行在导出时会被复制 — 将“商品行” / “合计行”变量放在此行。',
      colWidth: '列宽',
      rowHeight: '行高',
      hint: '双击或直接输入以编辑 · Enter / Tab 移动 · Alt+Enter 换行 · 右键插入 / 删除行列。',
    },
    sheet: {
      title: '工作表',
      sheetName: '工作表名称',
      fileName: '文件名',
      fileNameHint: '支持 {code}（单据编号）、{ngay}（导出日期）。',
      groupFile: '导出文件',
      groupPage: '页面',
      groupFont: '默认字体',
      fitWidth: '打印时宽度适合 1 页',
      gridLines: '在 Excel 中显示网格线',
      freezeRows: '冻结首行数',
    },
  },
  formulaDialog: {
    title: '创建公式',
    open: '公式',
    openHint: '用变量创建数字计算 / 文字连接公式（实时预览结果）',
    editHint: '正在编辑所选单元格 / 文字的公式',
    vars: '数据变量',
    varsHint: '点击插入到公式光标位置。',
    search: '搜索变量…',
    operators: '运算',
    functions: '常用函数',
    formula: '公式',
    placeholder: '如 {tongCong} + {thuKhac}   或   {customer} & " - " & {phone}',
    readable: '读作',
    result: '示例数据结果',
    resultEmpty: '从上方选择变量和运算开始',
    resultBlank: '（空）',
    error: '错误',
    insertAsExcel: '将写入单元格',
    insertAsPdf: '将插入模板',
    examples: '示例（点击使用）',
    exampleLabels: {
      add: '两数相加',
      mul: '计算 10%',
      join: '连接两段文字',
      bangchu: '金额大写',
    },
    ops: {
      add: '数字相加；若一方是文字则连接文字',
      addShort: '加',
      sub: '减',
      subShort: '减',
      mul: '乘（10% = 0.1）',
      mulShort: '乘',
      div: '除',
      divShort: '除',
      paren: '括号 — 先计算括号内',
      parenShort: '括号',
      join: '连接文字：把值并排拼接，不做加法',
      joinShort: '连接',
      space: '连接并在中间加空格',
      spaceShort: '连接+空格',
      text: '固定文字 — 在引号之间输入',
      textShort: '文字',
    },
    fns: {
      sum: 'SUM(a; b; …) — 求和',
      round: 'ROUND(数字; 小数位) — 四舍五入',
      if: 'IF(条件; 为真; 为假) — 如 IF({giamGia} > 0; "有折扣"; "")',
      text: 'TEXT(数字; 小数位) — 带千位分隔符',
      bangchu: 'BANGCHU(数字) — 越南语金额大写',
      upper: 'UPPER(文字) — 大写',
    },
    help:
      '• + − × ÷ 计算数字；& 连接文字（"0123" 保持原样，不相加）。\n' +
      '• 固定文字放在引号中："合计：" & {tongCong}。\n' +
      '• 千位写 1000 或 1.000；小数写 1.5。函数参数用 ; 或 , 分隔\n' +
      '• Excel：整个单元格写成 =公式。PDF：在文字中插入 {= 公式 }，用“预览”查看结果。',
    cancel: '取消',
    apply: '插入公式',
  },
}
